const styles = {
  container: {
    width: 'fit-content',
    maxWidth: '30rem'
  },
}

export default styles;